export default __webpack_public_path__ + "static/media/newlogin.1bf05181.jpg";